import { useCategory } from "@root/hooks/useCategory";
import React, { createContext, useContext, ReactNode } from "react";

const defaultState: any = {};

const CategoryContext = createContext<any>(defaultState);

interface CategoryProviderProps {
  children: ReactNode;
}

export const CategoryProvider: React.FC<CategoryProviderProps> = ({
  children,
}) => {
  const data = useCategory();
  return (
    <CategoryContext.Provider value={data}>{children}</CategoryContext.Provider>
  );
};

export const useCategoryContext = () => {
  return useContext(CategoryContext);
};
